export default "__VITE_ASSET__c898bc29__"